import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import {
  addQuestionToRepository,
  questionDetailItem as editQuestionInRepository,
} from 'utils/urls';

import { AddEditQuestionsType } from 'types/questions';
import { ErrorModal } from 'types/modalTypes';

export async function saveQuestion(
  params: AddEditQuestionsType,
): Promise<TResult> {
  const { Id } = params;
  const response = await fetch(
    Id === 0 ? addQuestionToRepository : editQuestionInRepository(Id),
    {
      method: Id === 0 ? 'POST' : 'PUT',
      headers: {
        Authorization: getTokenWithType(),
        'content-type': 'application/json',
      },
      body: JSON.stringify(params),
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: AddEditQuestionsType;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = AddEditQuestionsType;

type TSnapshot = unknown;

function useSaveQuestion(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: AddEditQuestionsType) => {
    if (params.QuestionTypeOption?.$type === 'ChoiceQuestionTypeOption') {
      if (params.Id === 0) {
        params = {
          ...params,
          QuestionTemplateOptions: params.QuestionTemplateOptions.map(
            (element: any) => {
              return {
                ...element,
                Id: 0,
              };
            },
          ),
        };
      } else {
        params = {
          ...params,
          QuestionTemplateOptions: params.QuestionTemplateOptions.map(
            (element: any) => {
              if (element.QuestionTemplateId === 0) {
                return {
                  ...element,
                  Id: 0,
                };
              } else return element;
            },
          ),
        };
      }
    }

    const newQuestion = await saveQuestion(params);
    if (newQuestion.Data) {
      queryClient.invalidateQueries(['questions_list'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_question_detail'], {
        refetchInactive: true,
      });
    } else if (newQuestion.Errors) throw newQuestion;

    return newQuestion;
  });
}

export { useSaveQuestion };
